export const TAB_OVERVIEW = "overview";

export const TAB_MATERIALS_PRICING = "materials-pricing";
